function InfoResult ({ label, value}) {
    return (
        <div className='info-result'>
            <span className="info-result-label">{label}:</span>
            <span className="info-result-value">{value}</span>
        </div>
    )
}

export default InfoResult;